module.exports = __webpack_public_path__ + "static/media/elements.26c5d9d9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/help/elements.gif
// module id = 434
// module chunks = 0